import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import AutoResizingTextArea from 'approot/shared/auto-resizing-textarea/auto-resizing-textarea';
import {
  baseFlexCss,
  flexSpaceBetweenCss,
} from 'approot/shared/styles/flex.style';
import {
  ItemsPerRowProps,
  MultipleChoiceImageProps,
  MultipleChoiceLetter,
  OptionSizeProps,
  itemsPerRowCss,
  optionSize,
} from './multiple-choice.style';
import { ActivityPosition } from 'global/constants';

export const MultipleChoiceEditBox = styled.div<
  OptionSizeProps &
    ItemsPerRowProps & {
      $isText?: boolean;
    }
>`
  ${flexSpaceBetweenCss}
  ${optionSize}
  ${itemsPerRowCss}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  padding: ${({ $isText }) => ($isText ? rem(spacing16) : rem(spacing4))};
`;

export const MultipleChoiceEditBoxContent = styled.div<
  MultipleChoiceImageProps & {
    $imagePosition?: ActivityPosition | null;
  }
>`
  ${baseFlexCss}
  gap: ${rem(spacing12)};
  position: relative;
  flex-grow: 1;
  width: 100%;

  // remove 2px right padding to cater for border around
  // the input field
  ${MultipleChoiceLetter} {
    margin-right: ${rem(10)};
  }
`;

type MultipleChoiceTextContentProps = {
  $hasPadding?: boolean;
};
export const MultipleChoiceTextContent = styled.div<MultipleChoiceTextContentProps>`
  ${flexSpaceBetweenCss}
  width: 100%;

  ${({ $hasPadding }) =>
    $hasPadding &&
    `
    padding: 0 0 0 ${rem(spacing16)};
  `};
`;

type MultipleChoiceEditInputProps = {
  $fontSize: number;
  $lineHeight: number;
};
export const MultipleChoiceEditInput = styled(
  AutoResizingTextArea
)<MultipleChoiceEditInputProps>`
  ${({ $fontSize, $lineHeight }) => `
    font-size: ${rem($fontSize)};
    line-height: ${rem($lineHeight)};
  `}

  border: 1px solid ${grey1};
  min-height: 0;
  padding: 0;
  width: 100%;
`;
